import { createContext } from "react";

export const ProgressContext = createContext<any>(0);
export const UserContext = createContext<any>("");
